import { OperatorLegendBar } from '../OperatorLegendBar'
import type { MapPickerItem } from './mapPickerTypes'

type MapPickerCardProps = {
  item: MapPickerItem
  onSelect: (id: string) => void
}

/** Operator / asset tile inside the map picker overlay (mobile OperatorCard parity). */
export function MapPickerCard({ item, onSelect }: MapPickerCardProps) {
  return (
    <button type="button" className="map-picker-card" onClick={() => onSelect(item.id)}>
      <div className="map-picker-card-head">
        <span className="map-picker-card-title">{item.title}</span>
        {item.subtitle ? <span className="map-picker-card-subtitle">{item.subtitle}</span> : null}
      </div>
      {item.legendItems?.length ? (
        <OperatorLegendBar
          className="map-picker-card-legend"
          items={item.legendItems}
          ariaLabel={`${item.title} map legend`}
        />
      ) : null}
    </button>
  )
}
